import React, {CSSProperties} from "react";

import {IPlanShortItem} from "features/plan/types";
import {Button, Radio} from "shared/ui";

interface Props {
  plan: IPlanShortItem;
  selected: boolean;
  style?: CSSProperties;
  onSelect: (plan: IPlanShortItem) => void;
}

const PlanItem = ({selected, onSelect, plan, style}: Props) => {
  const handleSelect = (e: any) => {
    if (!selected) onSelect(plan);
  };
  
  return (<Button
    variant={"text"}
    style={style}
    className={"plan-item"}
    onClick={handleSelect}
  >
    <Radio checked={selected} onChange={handleSelect}>
      {plan.cluster_id}
    </Radio>
    <span className={"type"}>
        {plan.shipping_item_count}
      </span>
  </Button>);
};

export default PlanItem;
